module.exports = __webpack_public_path__ + "img/PD1505009650888736768.9800c880.png";